import { render, staticRenderFns } from "./Setpassword.vue?vue&type=template&id=2f4af290&scoped=true"
import script from "./Setpassword.vue?vue&type=script&lang=js"
export * from "./Setpassword.vue?vue&type=script&lang=js"
import style0 from "./Setpassword.vue?vue&type=style&index=0&id=2f4af290&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4af290",
  null
  
)

export default component.exports